// sandbox to play around and test things out...
$(".team-module__testimg").click(function() {
    $(this).css({
        transform: 'scale(2.3)',
        origin: 'top'
    });

});



$('.contact-module__mail-input').keypress(function() {
    // $('#subscribe').addClass('wow fadeIn');
    $('#subscribe').removeClass('visibility-hidden');
})


$('#navbar-close').click(function() {
    // $('#subscribe').addClass('wow fadeIn');
    $('.desktop-navigation-wrapper').addClass('hide');
})



// WEBPACK FOOTER //
// ./assets/js/features/test.js